// extracted by mini-css-extract-plugin
export default {"protocol_modal":"style_protocol_modal__Gk7u+"};